export default async function logoutUser() {
  window.location.href = '/logout';
}
